/**
 * Sticky add-to-cart bar — shows when BOGO bundle section leaves the viewport.
 * Prices sync with selected bundle row; button triggers main product form submit.
 */
(function () {
  const sticky = document.querySelector('sticky-atc.sticky-atc');
  if (!sticky) return;

  const sectionId = sticky.getAttribute('data-section-id');
  const productFormId = sticky.getAttribute('data-product-form-id');
  const targetSelector = sticky.getAttribute('data-target');
  const bogoRoot = document.querySelector(
    '[data-bogo-bundles-root][data-section-id="' + sectionId + '"]'
  );
  const btn = sticky.querySelector('.sticky-atc__button');
  const priceEl = sticky.querySelector('.js-sticky-atc-price');
  const compareEl = sticky.querySelector('.js-sticky-atc-compare');
  const spinnerEl = sticky.querySelector('.sticky-atc__button-spinner');
  const configEl = document.getElementById('StickyAtcConfig-' + sectionId);
  const bogoConfigEl = document.getElementById('BogoBundleConfig-' + sectionId);

  if (!btn || !bogoRoot) return;

  let stickyConfig = {};
  let bogoConfig = {};
  let cachedVariant = null;

  try {
    if (configEl) stickyConfig = JSON.parse(configEl.textContent);
  } catch (e) {
    /* keep defaults */
  }

  try {
    if (bogoConfigEl) bogoConfig = JSON.parse(bogoConfigEl.textContent);
  } catch (e) {
    /* keep defaults */
  }

  function formatMoneyFromCents(cents) {
    if (cents == null || isNaN(Number(cents))) return '';
    const amount = Number(cents) / 100;
    const code = stickyConfig.currencyCode || bogoConfig.currencyCode || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function getVariantFromForm() {
    if (cachedVariant) return cachedVariant;

    const variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (variantSelects) {
      const jsonEl = variantSelects.querySelector('script[data-selected-variant]');
      if (jsonEl) {
        try {
          return JSON.parse(jsonEl.textContent);
        } catch (e) {
          /* fall through */
        }
      }
    }

    const form = document.getElementById(productFormId);
    if (!form) return null;
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return null;
    return { id: idInput.value, price: null, compare_at_price: null };
  }

  function getRowConfig(rowIndex) {
    const rows = bogoConfig.rows || [];
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].index === rowIndex) return rows[i];
    }
    return null;
  }

  function calcBundleTotals(rowIndex, variant) {
    const row = getRowConfig(rowIndex);
    if (!row) return { totalDiscounted: 0, totalOriginal: 0 };

    const qty = typeof row.qty === 'number' ? row.qty : parseInt(row.qty, 10) || 1;
    const discount = typeof row.discount === 'number' ? row.discount : parseInt(row.discount, 10) || 0;
    const bundleBaseCents =
      typeof stickyConfig.bundleBasePerPairCents === 'number'
        ? stickyConfig.bundleBasePerPairCents
        : typeof bogoConfig.bundleBasePerPairCents === 'number'
          ? bogoConfig.bundleBasePerPairCents
          : 0;

    let totalOriginal = 0;
    let totalDiscounted = 0;

    if (stickyConfig.dynamic && variant && variant.price != null) {
      const priceCents = variant.price;
      const compareCents = variant.compare_at_price || 0;
      let basePerPair = compareCents > priceCents ? compareCents : priceCents;

      if (bundleBaseCents > 0) {
        totalOriginal = qty * bundleBaseCents;
        totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
      } else if (qty === 1) {
        totalOriginal = basePerPair;
        totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
      } else {
        totalOriginal = qty * basePerPair;
        totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
      }
    }

    return { totalDiscounted: totalDiscounted, totalOriginal: totalOriginal };
  }

  function getActiveRowIndex() {
    const checked = bogoRoot.querySelector('.js-bogo-bundle-input:checked');
    if (checked) {
      const idx = parseInt(checked.getAttribute('data-bogo-row-index'), 10);
      if (!isNaN(idx)) return idx;
    }
    return stickyConfig.defaultRow || parseInt(sticky.getAttribute('data-default-row'), 10) || 2;
  }

  function updatePrices() {
    const rowIndex = getActiveRowIndex();
    const variant = getVariantFromForm();
    const totals = calcBundleTotals(rowIndex, variant);

    if (priceEl && totals.totalDiscounted > 0) {
      priceEl.textContent = formatMoneyFromCents(totals.totalDiscounted);
    }

    if (compareEl) {
      if (totals.totalOriginal > totals.totalDiscounted) {
        compareEl.textContent = formatMoneyFromCents(totals.totalOriginal);
        compareEl.hidden = false;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        compareEl.setAttribute('hidden', '');
      }
    }

    if (variant && variant.id) {
      btn.setAttribute('data-variant-id', String(variant.id));
    }
  }

  function syncSubmitState() {
    const submitBtn = targetSelector ? document.querySelector(targetSelector) : null;
    if (!submitBtn) return;

    const disabled =
      submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true';
    btn.disabled = disabled;
    if (disabled) {
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('aria-disabled');
    }
  }

  function setVisible(show) {
    if (show) {
      sticky.classList.add('sticky-atc--visible');
      sticky.removeAttribute('hidden');
      sticky.removeAttribute('aria-hidden');
    } else {
      sticky.classList.remove('sticky-atc--visible');
      sticky.setAttribute('hidden', '');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function initObserver() {
    if (!('IntersectionObserver' in window)) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting);
        });
      },
      { root: null, threshold: 0 }
    );

    observer.observe(bogoRoot);
  }

  function watchSubmitLoading() {
    const submitBtn = targetSelector ? document.querySelector(targetSelector) : null;
    if (!submitBtn || !window.MutationObserver) return;

    const observer = new MutationObserver(function () {
      const loading = submitBtn.classList.contains('loading');
      btn.classList.toggle('loading', loading);
      if (spinnerEl) {
        if (loading) {
          spinnerEl.hidden = false;
          spinnerEl.removeAttribute('hidden');
        } else {
          spinnerEl.hidden = true;
          spinnerEl.setAttribute('hidden', '');
        }
      }
      syncSubmitState();
    });

    observer.observe(submitBtn, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled'],
    });
  }

  bogoRoot.querySelectorAll('.js-bogo-bundle-input').forEach(function (radio) {
    radio.addEventListener('change', function () {
      updatePrices();
      syncSubmitState();
    });
  });

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    const submitBtn = targetSelector ? document.querySelector(targetSelector) : null;
    if (!submitBtn || submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true') {
      return;
    }
    submitBtn.click();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const data = event && event.data;
      if (!data || String(data.sectionId) !== String(sectionId)) return;
      if (data.variant) cachedVariant = data.variant;
      requestAnimationFrame(function () {
        updatePrices();
        syncSubmitState();
      });
    });
  }

  initObserver();
  cachedVariant = getVariantFromForm();
  updatePrices();
  syncSubmitState();
  watchSubmitLoading();
})();
